<template>
  <el-menu ref="refMenu" v-bind="$attrs" v-on="menuEmit" class="recursive-menu">
    <RecursMenuItem v-for="(item, i) in data" :key="i" :menuNode="item" />
  </el-menu>
</template>

<script>
import RecursMenuItem from "./RecursiveMenuItem.vue";
export default {
  name: "RecursiveMenu",
  components: {
    RecursMenuItem
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    defaultSelect: {
      type: String,
      default: () => ""
    },
    scrollTarget: {
      type: String,
      default: () => ""
    }
  },
  data() {
    const emiters = ["open", "close", "select", "hook:mounted"];
    this.menuEmit = emiters.reduce((pre, cur) => {
      pre[cur] = (...args) => this.menuEvent(cur, ...args);
      return pre;
    }, {});
    this.selSub = null;
    return {
      menuMounted: false
    };
  },
  computed: {},
  watch: {
    defaultSelect(newVal) {
      if (this.selSub) {
        this.selSub.classList.remove("is-select");
      }
      if (this.menuMounted && newVal && this.$refs.refMenu.submenus[newVal]) {
        this.$nextTick(() => {
          this.selSub = this.$refs.refMenu.submenus[newVal].$el;
          this.selSub.classList.add("is-select");
        });
      }
    }
  },
  mounted() {},
  beforeDestroy() {
    this.selSub = null;
  },
  methods: {
    menuEvent(key, index, indexPath) {
      this.$emit(key, index, indexPath);
      switch (key) {
        case "hook:mounted":
          this.menuMounted = true;
          let menu = this.$refs.refMenu;
          let unwatch;
          unwatch = menu.$watch(
            "submenus",
            function(newVal) {
              if (newVal[this.defaultSelect]) {
                this.selSub = newVal[this.defaultSelect].$el;
                this.selSub.classList.add("is-select");
                unwatch();
              }
            }.bind(this)
          );
          break;
        case "open":
          if (this.selSub) {
            this.selSub.classList.remove("is-select");
          }
          this.$emit("select", index, indexPath);
          this.$nextTick(() => {
            this.selSub = this.$refs.refMenu.submenus[index].$el;
            this.selSub.classList.add("is-select");
          });
          break;
        case "close":
          if (this.selSub) {
            this.selSub.classList.remove("is-select");
          }
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style>
.recursive-menu {
  width: 100%;
  height: 100%;
}
.recursive-menu.el-menu {
  overflow: auto;
}
.recursive-menu.el-menu .el-menu-item,
.recursive-menu.el-menu .menu_span,
.recursive-menu.el-menu .el-submenu__title {
  padding-right: 0;
  height: auto;
}
.recursive-menu.el-menu .menu_item_title {
  word-wrap: break-word;
  white-space: normal;
}
.recursive-menu.el-menu .el-menu-item.is-active {
  border-right: 2px solid #409eff;
}
.recursive-menu.el-menu .el-submenu.is-select > .el-submenu__title {
  border-right: 2px solid #409eff;
}
/* .recursive-menu .el-menu .el-submenu .el-menu .menu_item_title {
  border-left: 1px solid #d4d4d4;
} */
</style>



// WEBPACK FOOTER //
// src/components/RecursiveMenu/RecursiveMenu.vue